interface state extends types.redux.rootReducer {}

export const selectedAccountSelector = ({ selectedAccount }: state) => selectedAccount.value;
export const allAccountSelector = ({ selectedAccount }: state) => {
    return selectedAccount?.allAccounts || [];
}

